import React, { useState } from 'react';
import posthog from 'posthog-js';
import { useModal } from '../context/ModalContext';
import './ContactModal.css';

export default function ContactModal() {
    const { isModalOpen, closeModal } = useModal();
    const [formData, setFormData] = useState({
        naam: '',
        contact: '',
        bericht: ''
    });
    const [submitted, setSubmitted] = useState(false);

    if (!isModalOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Track event in PostHog
        posthog.capture('contact_modal_submitted', {
            naam: formData.naam,
            contact: formData.contact,
            bericht: formData.bericht,
            source: window.location.pathname // Track where they opened it from
        });

        setSubmitted(true);

        // Reset form after delay
        setTimeout(() => {
            setSubmitted(false);
            setFormData({ naam: '', contact: '', bericht: '' });
            closeModal();
        }, 3000);
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            closeModal();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleBackdropClick}>
            <div className="modal-content">
                <button className="close-button" onClick={closeModal} aria-label="Sluiten">×</button>

                {submitted ? (
                    <div className="success-message">
                        <span className="success-icon">✅</span>
                        <h3>Bedankt!</h3>
                        <p>We nemen zo snel mogelijk contact met u op.</p>
                    </div>
                ) : (
                    <>
                        <div className="modal-header">
                            <h2>Neem contact op</h2>
                            <p>Vul uw gegevens in en wij nemen contact met u op.</p>
                        </div>

                        <form className="modal-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="modal-naam">Naam *</label>
                                <input
                                    type="text"
                                    id="modal-naam"
                                    name="naam"
                                    value={formData.naam}
                                    onChange={handleChange}
                                    required
                                    placeholder="Uw naam"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="modal-contact">Email of Telefoonnummer *</label>
                                <input
                                    type="text"
                                    id="modal-contact"
                                    name="contact"
                                    value={formData.contact}
                                    onChange={handleChange}
                                    required
                                    placeholder="bijv. 0612345678 of naam@bedrijf.nl"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="modal-bericht">Bericht (optioneel)</label>
                                <textarea
                                    id="modal-bericht"
                                    name="bericht"
                                    value={formData.bericht}
                                    onChange={handleChange}
                                    rows="3"
                                    placeholder="Waar kunnen we u mee helpen?"
                                ></textarea>
                            </div>

                            <button type="submit" className="submit-button">Versturen</button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}
